import type { DeviceInfo } from '../../domain/value-objects/DeviceInfo';

/**
 * Captures user device information
 * Only captures userAgent - IP is obtained in the Edge Function
 */
export const captureDeviceInfo = (): DeviceInfo => {
  return {
    userAgent: navigator.userAgent,
  };
};
